import * as Sentry from '@sentry/angular'
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { enableProdMode, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { IndustrySectorService } from '@app/v2/shared/services/industry-sector.service'
import { NbEvaIconsModule } from '@nebular/eva-icons'
import { NbChatModule, NbDatepickerModule, NbDialogModule, NbMenuModule, NbSidebarModule, NbThemeModule, NbToastrModule, NbWindowModule } from '@nebular/theme'
import { firstValueFrom, of } from 'rxjs'
import { AppComponent } from './app/app.component'
import { EventParserService } from './app/modules/events/services/event-parser.service'
import { BetaFeaturesInterceptor } from './app/services/beta-features.interceptor'
import { TokenInterceptorFn } from './app/services/token.interceptor'
import { provideTranslation } from './app/v2/config/translation.providers'
import { environment } from './environments/environment'
import { routes } from './routes'
import { switchMap } from 'rxjs/operators'

if (environment.production) {
  Sentry.init({
    dsn: environment.sentry?.dsn,
    environment: environment.sentry?.environment,
    sampleRate: environment.sentry?.sampleRate,
    tracesSampleRate: environment.sentry?.tracesSampleRate
  })
  enableProdMode()
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([TokenInterceptorFn, BetaFeaturesInterceptor])),
    provideAppInitializer(() => {
      const authService = inject(AuthService)
      // If an IdP web session exists, this fetches an access token (in memory) and hydrates the user.
      return firstValueFrom(authService.getAccessToken$().pipe(switchMap((t) => (t ? authService.getUserData() : of(null)))))
        .then(() => {
          if (authService.isLoggedIn) {
            authService.clearCrossAppRedirectState()
          }
        })
        .then(() => undefined)
    }),

    provideAppInitializer(() => {
      const industrySectorService = inject(IndustrySectorService)
      return industrySectorService.loadIndustrySectors()
    }),

    importProvidersFrom(
      NbThemeModule.forRoot({ name: 'default' }),
      NbEvaIconsModule,
      NbDialogModule.forRoot(),
      NbWindowModule.forRoot(),
      NbToastrModule.forRoot({
        duration: 50,
        destroyByClick: true
      }),
      NbDatepickerModule.forRoot(),
      NbChatModule.forRoot({
        messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY'
      }),
      NbMenuModule.forRoot(),
      NbSidebarModule.forRoot()
    ),
    EventParserService,
    provideTranslation(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    }
  ]
}).catch((err) => console.error(err))
